import sdk from '../lib/sdk';
import md5 from 'md5';

export class Xianwan {
	constructor() {
		this.postData = undefined;
		this.baseUrl = 'https://h5.17xianwan.com/try/try_list_plus';
		this.init();
	}

	init() {
		const userInfo = sdk.getUserInfo();
		// ios - 1 android - 2
		const ptype = '2';
		// deviceid
		// const deviceid = userInfo['device-id'];
		const deviceid = userInfo['imei'] || 0;
		// androidosv
		const androidosv = userInfo['osversion'];
		// 安全联盟OAID
		const msaoaid = userInfo.oaid;
		// 客户端的用户id
		const appsign = userInfo.uid;
		// 所示的打开相册 scheme唤醒功能
		const xwversion = '2';
		// 开发者id(闲玩提供)
		const appid = '8707';
		// 同服务端KEY
		const appsecret = 'iu44jrezm7j11nr0';
		// md5加密keycode
		const keycode = md5(appid + deviceid + msaoaid + androidosv + ptype + appsign + appsecret);
		this.postData = {
			ptype,
			deviceid,
			androidosv,
			msaoaid,
			appid,
			appsign,
			xwversion,
			keycode,
		};
	}

	/**
	 * @description: 跳转到闲玩
	 * @return {void}
	 */
	async hrefToXianwan() {
		const baseUrl = 'https://h5.17xianwan.com/try/try_list_plus';
		// 拼接请求地址
		let paramsStr = '?';
		const keyArr = Object.keys(this.postData);
		keyArr.forEach((key, index) => {
			paramsStr += `${key}=${this.postData[key]}`;
			if (index < keyArr.length - 1) {
				paramsStr += '&';
			}
		});
		const url = baseUrl + paramsStr;
		const data = { url };
		sdk.openPageWithJSON(JSON.stringify(data));
	}
}



// WEBPACK FOOTER //
// ./src/lib/xianwan.js